/** Topbar notification poll: 60s base, cap 15m, reset on success. */

export const NOTIFICATION_POLL_BASE_MS = 60_000;
export const NOTIFICATION_POLL_MAX_MS = 15 * 60_000;

export function nextNotificationPollDelay(currentDelayMs: number, succeeded: boolean): number {
  if (succeeded) return NOTIFICATION_POLL_BASE_MS;
  const current =
    Number.isFinite(currentDelayMs) && currentDelayMs > 0
      ? currentDelayMs
      : NOTIFICATION_POLL_BASE_MS;
  return Math.min(Math.max(current, NOTIFICATION_POLL_BASE_MS) * 2, NOTIFICATION_POLL_MAX_MS);
}
